<template>
  <div v-show="show" class="pre-export-component-template">
    <div class="bro-check-body">
      <p class="bro-check-header">{{ $t('preExport.BROSADCorrectionReason.label.header') }}</p>
      <p class="bro-check-explanation">{{ $t('preExport.BROSADCorrectionReason.label.explanation') }}</p>

      <DxSelectBox v-model="selectedReason" class="reason-select" :data-source="reasons" display-expr=displayValue value-expr="value"
        @value-changed="updateReason" />
    </div>
  </div>
</template>

<script>
import '@/assets/less/colors.less'

import DxSelectBox from 'devextreme-vue/select-box'

export default {
  name: 'BROSADCorrectionReason',
  data() {
    return {
      reasons: [
        {
          value: 'bronhouder',
          displayValue: this.$t('preExport.BROSADCorrectionReason.reasons.bronhouder')
        },
        {
          value: 'eigenCorrectie',
          displayValue: this.$t('preExport.BROSADCorrectionReason.reasons.eigenCorrectie')
        },
        {
          value: 'inOnderzoek',
          displayValue: this.$t('preExport.BROSADCorrectionReason.reasons.inOnderzoek')
        },
        {
          value: 'kwaliteitsregime',
          displayValue: this.$t('preExport.BROSADCorrectionReason.reasons.kwaliteitsregime')
        }
      ],
      selectedReason: null,
      show: true
    }
  },
  computed: {
    getExportProjects() {
      return this.$store.getters.getExportInformationExportProjects
    }
  },
  props: {
    projectId: {
      type: String,
      required: true
    }
  },
  components: {
    DxSelectBox
  },
  mounted() {
    this.$emit('preExportCheckUpdated')
  },
  methods: {
    updateReason(event) {
      this.$store.commit('updateExportProjectConversionContext', { PrID: this.projectId, conversionContext: { broCorrectionReason: this.selectedReason } })
    }
  }
}
</script>

<style lang="less" scoped>
.pre-export-component-template {
  background: @gray100;
  padding: 16px;
}
.reason-select {
  width: 100%;
  height: 50px;
  border: 1px solid #dbd9d7;
  border-radius: 4px;
}
</style>
